
import { Dropdown } from "react-bootstrap";
import {
    LuChevronUp,
    LuChevronDown,
    LuArrowUpDown,
} from "react-icons/lu";
import { BsOpenai } from "react-icons/bs";
import {
    MdOutlineCheckCircle,
    MdOutlineCircle,
} from "react-icons/md";

import { useLanguage } from "../../../Translations/LenguageContext";
import LoaderSimulationsTable from "../../../Loaders/LoaderSimulationsTable";
import { FaArrowTrendDown, FaArrowTrendUp, FaArrowsLeftRight } from "react-icons/fa6";
import FormatDateTime from "../../../Functions/FormatDate";
import { PiMagnifyingGlass } from "react-icons/pi";

const EngineCell = ({ record }) => (
    <div className="custom_cell_user" title={record.engine}>
        <div
            className="prompts_run_engine_icons"
            style={
                record.engine !== "chatgpt"
                    ? {
                        backgroundImage: `url('/logos/${record.engine}.png')`,
                    }
                    : undefined
            }
        >
            {record.engine === "chatgpt" && (
                <span>
                    <BsOpenai />
                </span>
            )}
        </div>
    </div>
);

const MetricCell = ({ value }) => (
    <div
        className="simulation_metric_cell"
        title={value ?? "—"}
    >
        {value < 4 ? (
            <span className="simulation_metric_cell_span simulation_metric_cell_negative">
                {value ?? "—"}
                <i><FaArrowTrendDown /></i>
            </span>
        ) : (value >= 4 && value <= 6) ? (
            <span className="simulation_metric_cell_span simulation_metric_cell_warning">
                {value ?? "—"}
                <i><FaArrowsLeftRight /></i>
            </span>
        ) : (
            <span className="simulation_metric_cell_span simulation_metric_cell_positive">
                {value ?? "—"}
                <i><FaArrowTrendUp /></i>
            </span>
        )}
    </div>
);

const GeoOverviewTable = ({
    simulations = [],
    loadingSimulations,
    pagination,
    engines = [],
    simulationCount,
    selectedEngine,
    searchTerm,
    onSearchChange,
    sortConfig,
    onSort,
    onEngineChange,
    onPageChange,
    handleOpenSinglePromptSimulation
}) => {
    const { t } = useLanguage();

    const headers = [
        { key: "engine", label: t.geo.engine, sortable: false },
        { key: "prompt", label: t.geo.prompt, sortable: true },
        {
            key: "effectiveness_score",
            label: t.geo.effectiveness,
            sortable: true,
        },
        { key: "visibility", label: t.geo.visibility, sortable: true },
        { key: "sentiment", label: t.geo.sentiment, sortable: true },
        { key: "position", label: t.geo.position, sortable: true },
        { key: "created_at", label: t.created_at, sortable: true },
        { key: "settings", label: "", sortable: false },
    ];

    const renderSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <LuArrowUpDown className="simulation_sort_icon" />;
        }

        return sortConfig.direction === "asc"
            ? <LuChevronUp className="simulation_sort_icon" />
            : <LuChevronDown className="simulation_sort_icon" />;
    };

    return (
        <div className="geo_overview_res_table_cont fade-in">
            {loadingSimulations ? (
                <LoaderSimulationsTable />
            ) : (
                <div className="geo_overview_res_table">
                    <div className="custom_table_simulations_cont">
                        <table className="custom_table">
                            <thead>
                                <tr className="custom_table_tr_th">
                                    {headers.map((header) => (
                                        <th
                                            key={header.key}
                                            className={`custom_table_th ${header.key === "engine"
                                                ? "engine_dropdown_header"
                                                : header.sortable
                                                    ? "sortable_header"
                                                    : ""
                                                }`}
                                        >
                                            {header.key === "engine" ? (
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        as="button"
                                                        className="simulation_sort_button"
                                                    >
                                                        {selectedEngine
                                                            ? selectedEngine
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                            selectedEngine.slice(1)
                                                            : "Select engine"}
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu className="custom_dropdown_menu">
                                                        <div className="dropdown_container fade-in">
                                                            <div className="scrollable_dropdown_cont">
                                                                {engines.length > 0 ? (
                                                                    engines.map((engine) => (
                                                                        <button
                                                                            key={engine}
                                                                            type="button"
                                                                            className="settings_link"
                                                                            style={{
                                                                                textTransform: "capitalize",
                                                                            }}
                                                                            onClick={() =>
                                                                                onEngineChange(engine)
                                                                            }
                                                                        >
                                                                            <i>
                                                                                {selectedEngine === engine
                                                                                    ? <MdOutlineCheckCircle />
                                                                                    : <MdOutlineCircle />
                                                                                }
                                                                            </i>
                                                                            {engine}
                                                                        </button>
                                                                    ))
                                                                ) : (
                                                                    <div className="no_data_dropdown fade-in">
                                                                        <p>
                                                                            {t?.no_data_found_by_search ||
                                                                                "No results found"}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="filter_dropdown fade-in">
                                                                <input
                                                                    className="filter_input"
                                                                    placeholder={t?.search_filter}
                                                                    value={searchTerm}
                                                                    onChange={(event) =>
                                                                        onSearchChange(
                                                                            event.target.value
                                                                        )
                                                                    }
                                                                    onClick={(event) =>
                                                                        event.stopPropagation()
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="simulation_sort_button"
                                                    onClick={() =>
                                                        onSort(header.key)
                                                    }
                                                    title={`Sort by ${header.label}`}
                                                >
                                                    {header.key != "settings" && (
                                                        <>
                                                            <span>{header.label}</span>
                                                            {renderSortIcon(header.key)}
                                                        </>
                                                    )}
                                                </button>
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="custom_table_body">
                                {simulations.length > 0 ? (
                                    simulations.map((item) => (
                                        <tr
                                            key={item.id}
                                            className="custom_table_row"
                                        >
                                            <td className="custom_table_td td_user">
                                                <EngineCell record={item} />
                                            </td>

                                            <td className="custom_table_td custom_table_td_prompt">
                                                <span
                                                    className="simulation_prompt_id"
                                                    title={item.prompt || ""}
                                                >
                                                    {item.prompt || "—"}
                                                </span>
                                            </td>

                                            <td className="custom_table_td">
                                                <MetricCell
                                                    value={item.effectiveness_score}
                                                />
                                            </td>

                                            <td className="custom_table_td">
                                                <MetricCell
                                                    value={item.visibility}
                                                />
                                            </td>

                                            <td className="custom_table_td">
                                                <MetricCell
                                                    value={item.sentiment}
                                                />
                                            </td>

                                            <td className="custom_table_td">
                                                <MetricCell
                                                    value={item.position}
                                                />
                                            </td>

                                            <td className="custom_table_td">
                                                {FormatDateTime(item.created_at)}
                                            </td>
                                            <td className="custom_table_td custom_table_td_click" onClick={() => handleOpenSinglePromptSimulation(item.id)}>
                                                <PiMagnifyingGlass />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="custom_table_row_empty">
                                        <td
                                            colSpan={headers.length}
                                            className="custom_table_td_empty"
                                        >
                                            {t?.no_data_found ||
                                                "No simulations found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {pagination && (
                <div className="simulation_pagination">
                    <span className="simulation_pagination_info">
                        {pagination.total ?? simulationCount ?? 0} {simulationCount > 1 ? t.geo.simulations : t.geo.simulation}
                        {" · "}
                        {t.page} {pagination.page ?? 1} of{" "}
                        {pagination.total_pages ?? 1}
                    </span>

                    <div className="simulation_pagination_buttons">
                        <button
                            type="button"
                            className={`simulation_page_button ${(loadingSimulations || (pagination.page ?? 1) <= 1) && "simulation_page_button_disabled"}`}
                            disabled={
                                loadingSimulations ||
                                (pagination.page ?? 1) <= 1
                            }
                            onClick={() =>
                                onPageChange(
                                    (pagination.page ?? 1) - 1
                                )
                            }
                        >
                            <i className="fa-solid fa-chevron-left" />
                            {" "}{t.back}
                        </button>

                        <button
                            type="button"
                            className={`simulation_page_button ${(loadingSimulations || !pagination.has_next) && "simulation_page_button_disabled"}`}
                            disabled={
                                loadingSimulations ||
                                !pagination.has_next
                            }
                            onClick={() =>
                                onPageChange(
                                    (pagination.page ?? 1) + 1
                                )
                            }
                        >
                            {t.next}{" "}
                            <i className="fa-solid fa-chevron-right" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GeoOverviewTable;
